import { type ComponentProps } from 'react';
import { Search } from 'lucide-react';

import { InputGroup, InputGroupIcon, InputGroupInput } from '@/components/Input/InputGroup';
import { cn } from '@/util/utils';

type SearchInputProps = Omit<ComponentProps<'input'>, 'size' | 'type'> & {
    /** 36px, or the 32px `sm` a search inside a panel's own head uses. */
    size?: 'default' | 'sm';
    /**
     * A plain text box with the search look. For a field that searches within a screen that
     * already has THE search: a second searchbox role confuses a screen reader and a test
     * looking for "the search" alike (the filter drawer's wardrobe field).
     */
    plain?: boolean;
    /** The box around the field, for its width in a row. */
    className?: string;
};

/**
 * ui-input with `icon="search"`: the control box with the 15px magnifier before the field. One
 * search field for every list, instead of each screen building InputGroup and the icon by hand,
 * and three pickers drawing a bare input with no icon at all (ALS-275).
 */
function SearchInput({
    size = 'default',
    plain = false,
    className,
    ref,
    ...props
}: SearchInputProps) {
    return (
        <InputGroup data-slot="search-input" className={cn(size === 'sm' && 'h-8', className)}>
            <InputGroupIcon>
                <Search />
            </InputGroupIcon>
            <InputGroupInput ref={ref} type={plain ? 'text' : 'search'} {...props} />
        </InputGroup>
    );
}

export { SearchInput, type SearchInputProps };
